<template>
  <div :class="['header-mobile-menu', { 'show-top-navigation': state.activeLevelSequence.length > 0 }]">
    <div v-if="state.activeLevelSequence.length > 0" class="mobile-top-navigation">
      <button
        v-if="state.activeLevelSequence.length > 0"
        class="mobile-top-navigation__back"
        @click="backLevel"></button>

      <div class="mobile-top-navigation__title">{{ state.activeLevel?.link?.title }}</div>

      <mobile-menu-toggle @close-menu="closeMenu" />
    </div>

    <div class="mobile-menu-content-wrapper">
      <Preloader v-if="!state.activeLevel" class="menu-loader" />
      <div v-else class="mobile-menu-list" :class="`level-${state.activeLevelSequence.length + 1}`">
        <a
          v-if="
            (state.activeLevel?.link?.url && state.activeLevel?.link?.url !== 'javascript:void(0)') ||
            state.activeLevel?.view_all_link === 1
          "
          :href="state.activeLevel?.view_all_link === 1 ? catalogLink : state.activeLevel?.link?.url"
          class="mobile-menu-list__item">
          All {{ state.activeLevel.link?.title }}
        </a>

        <a
          v-for="(item, index) in state.activeLevel?.children || state.activeLevel"
          @click.prevent="clickOnItem(index)"
          :key="index"
          :class="['mobile-menu-list__item', item?.children?.length > 0 ? 'has-children' : 'without-children']">
          <span class="title-block">
            <span class="title">{{ item?.link.title }}</span>
            <span v-if="item?.link?.subtitle" class="subtitle">{{ item?.link.subtitle }}</span>
          </span>
        </a>
      </div>

      <search v-if="state.activeLevelSequence.length === 0" class="search-form-mobile" />

      <span v-if="state.activeLevelSequence.length === 0" class="mobile-menu-separator"></span>

      <div v-if="state.activeLevelSequence.length === 0" class="mobile-menu-profile-actions">
        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <a :href="bidsLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-bids">
                <use href="/sprite.svg#bids"></use>
              </svg>
            </div>
            {{ trans("header.user_menu.bids") }}
          </a>
        </div>
        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <a :href="purchasesLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-shopping">
                <use href="/sprite.svg#shopping"></use>
              </svg>
            </div>
            {{ trans("header.user_menu.purchases") }}
          </a>
        </div>
        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <a :href="profileLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-user">
                <use href="/sprite.svg#user"></use>
              </svg>
            </div>
            {{ trans("header.user_menu.profile") }}
          </a>
        </div>

        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <a :href="messagesLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-message">
                <use href="/sprite.svg#mail"></use>
              </svg>
            </div>
            {{ trans("header.profile_icons.messages") }}
          </a>
          <message-counter class="mobile-action-counter" :init-count="unreadCount"></message-counter>
        </div>
        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <div @click="openNotificationsPanel" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-bell">
                <use href="/sprite.svg#bell"></use>
              </svg>
            </div>
            {{ trans("header.profile_icons.notifications") }}
          </div>
          <notification-counter class="mobile-action-counter notifications-counter" />
        </div>
        <div class="mobile-menu-profile-actions__item">
          <a :href="calendarLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon icon-calendar">
                <use href="/sprite.svg#calendar"></use>
              </svg>
            </div>
            {{ trans("header.profile_icons.calendar") }}
          </a>
        </div>
        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item">
          <a :href="bidsLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon-star">
                <use href="/sprite.svg#star"></use>
              </svg>
            </div>
            {{ trans("header.profile_icons.watching") }}
          </a>
        </div>

        <div v-if="auctionStore.user?.id" class="mobile-menu-profile-actions__item logout">
          <a href="#" class="mobile-action-link" @click.prevent="logout">
            <div class="icon-block">
              <svg class="icon-logout">
                <use href="/sprite.svg#logout"></use>
              </svg>
            </div>
            {{ trans("header.user_menu.logout") }}
          </a>
        </div>
        <div v-else class="mobile-menu-profile-actions__item logout">
          <a :href="loginLink" class="mobile-action-link">
            <div class="icon-block">
              <svg class="icon-logout">
                <use href="/sprite.svg#logout"></use>
              </svg>
            </div>
            {{ trans("header.login") }}
          </a>
        </div>

        <span class="mobile-menu-separator"></span>

        <div class="mobile-menu-profile-actions__item header__menu__language-switcher">
          <v-menu placement="right" theme="info-menu-without-arrow" :distance="10" :delay="50">
            <div class="popper-menu-wrapper">
              <span class="language-switcher__text mobile-action-link">
                {{ language?.toUpperCase() }}
              </span>
            </div>

            <template v-if="languages.length > 0" #popper>
              <div class="languages-list">
                <template v-for="lang in languages">
                  <div v-if="lang.abbr !== language" :key="lang.abbr" class="languages-list__inner-wrapper">
                    <div class="languages-list__item" @click="switchLanguage(lang)">
                      {{ lang.abbr?.toUpperCase() }}
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </v-menu>
        </div>
      </div>
    </div>
  </div>
  <notifications-panel
    :class="['mobile-notifications-panel', { hide: !state.isOpenNotificationPanel }]"
    is-mobile-menu-prop
    @closePanel="hideNotificationsPanel" />
</template>

<script setup lang="ts">
  import MobileMenuToggle from "@/components/menu-blocks/MobileMenuToggle.vue";
  import Search from "@/components/_partials/Search.vue";
  import MessageCounter from "@/components/menu-blocks/MessageCounter.vue";
  import { IMenuItem, ILanguage } from "@/models";
  import { computed, onMounted, reactive, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import apiClient from "@/services/api";
  import { trans } from "@/utils/trans";
  import NotificationCounter from "@/components/menu-blocks/NotificationCounter.vue";
  import NotificationsPanel from "@/components/menu-blocks/NotificationsPanel.vue";
  import Preloader from "@/components/_partials/Preloader.vue";

  const auctionStore = useAuctionStore();
  const menuItems = computed(() => auctionStore.menu);
  const unreadCount = auctionStore.user?.unreadMessageCount;

  const state = reactive({
    activeLevel: null as IMenuItem | null,
    activeLevelSequence: [],
    isOpenNotificationPanel: false
  });

  const bidsLink = computed(() => auctionStore.routes["profile.bids.active"]);
  const purchasesLink = computed(() => auctionStore.routes["profile.invoices.index"]);
  const profileLink = computed(() => auctionStore.routes["profile.info.edit"]);
  const calendarLink = computed(() => auctionStore.routes["site.auctions.show_calendar"]);
  const messagesLink = computed(() => auctionStore.routes["profile.messages.index"]);
  const loginLink = computed(() => auctionStore.routes["login"] + '?redirect=' + location.href);
  const catalogLink = computed(() => auctionStore.routes["site.lots.show_catalog"]);

  const languages = computed(() => auctionStore.languageSettings.languages);
  const language = computed(() => auctionStore.languageSettings.language ?? 'en');

  onMounted(() => {
    getLevelItemsBySequence();
  });

  watch(menuItems, () => {
    getLevelItemsBySequence();
  });

  const clickOnItem = (index: number) => {
    if (state.activeLevel) {
      if (state.activeLevel?.children[index]?.children?.length > 0) {
        state.activeLevel = state.activeLevel?.children[index];
        state.activeLevelSequence.push(index);
      } else {
        window.open(state.activeLevel?.children[index]?.link.url, "_self");
      }
    }
  };

  const backLevel = () => {
    state.activeLevelSequence.pop();
    getLevelItemsBySequence();
  };

  const getLevelItemsBySequence = () => {
    if (state.activeLevelSequence.length === 0) {
      state.activeLevel = { children: menuItems.value };
    } else {
      let result = menuItems.value;

      for (let i = 0; i < state.activeLevelSequence.length; i++) {
        result = result[state.activeLevelSequence[i]];
        if (result?.children && i !== state.activeLevelSequence.length - 1) {
          result = result.children;
        }
      }

      state.activeLevel = result;
    }
  };

  const switchLanguage = (language: ILanguage) => {
    apiClient.put(language.url).then((response) => {
      auctionStore.$patch((storeState) => {
        storeState.translations = response.data;
        storeState.languageSettings.language = language.abbr;
        storeState.languageSettings.htmlDirection = language.htmlDirection;
      });
    });
  };

  const closeMenu = () => {
    state.activeLevel = { children: menuItems.value };
    state.activeLevelSequence = [];
  };

  const openNotificationsPanel = () => {
    state.isOpenNotificationPanel = true;
  };

  const hideNotificationsPanel = () => {
    state.isOpenNotificationPanel = false;
  };

  const logout = () => {
    apiClient.post(auctionStore.routes["logout"]).then(() => {
      window.location.reload();
    });
  };
</script>

<style lang="scss" scoped>
  .mobile-menu-content-wrapper {
    position: relative;
    min-height: 200px;
  }

  .menu-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    :deep(.chase-dot) {
      &:before {
        background-color: #333;
      }
    }
  }
</style>
